import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f3f696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "file-btns" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { style: {"flex":"auto"} }
const _hoisted_6 = { style: {"height":"500px","flex":"auto"} }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"height":"50px","line-height":"50px","text-align":"right","padding-right":"20px"} }
const _hoisted_10 = { style: {"color":"red"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "将", -1))
const _hoisted_12 = { style: {"width":"300px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改为", -1))
const _hoisted_14 = { style: {"width":"300px"} }
const _hoisted_15 = { class: "operation-col" }


const __default__ = {
  name: 'ShopProduct'
};

import { computed, ref, watch } from 'vue';
import { OioButton, OioInput, OioModal, OioSpin, OioTag, OioDateTimePicker,OioMessage } from '@kunlun/vue-ui-antd';
import {
  PlusCircleOutlined,
  MinusCircleOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined
} from '@ant-design/icons-vue';
import { VxeTableInstance } from 'vxe-table';
import { cloneDeep } from 'lodash-es';
import { PopupManager, RuntimeModel } from '@kunlun/dependencies';
import { removeDecimalZero } from '../../../../utils/number';
import { vxeTableRemoveZeroFormatter } from '../../../../utils/fotmatter';
import { useFullscreen } from '../../../../hooks/fullscreen';
import { submitData } from './services';
import Decimal from 'decimal.js';

interface IProps {
  rModel: RuntimeModel;
  _dataSource: any[];
  _formData: any;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rModel: null,
    _dataSource: null,
    _formData: null
  },
  setup(__props: any) {

const props = __props as { rModel: RuntimeModel, _dataSource: any[], _formData: any }



const tableRef = ref<VxeTableInstance>();
const submitLoading = ref(false);
const editModalVisible = ref(false);
const editModalDataList = ref<any[]>([]);
const searchVal = ref('');
const tableLoading = ref(false);
const timeRuleOptions = ref<any[]>([
  {
    label: '按发货时间记账',
    value: 'DELIVERY_TIME'
  },
  {
    label: '按指定时间记账',
    value: 'TARGET_TIME'
  }
]);
const editModalConfirmLoading = ref(false);
const selectRecords = ref<any[]>([]);

let count = 1;

const contentRef = ref<HTMLElement | undefined>();
const { isFullscreen, toggleFullscreen } = useFullscreen(contentRef);

const displayTableData = ref<any[]>([]);
const totalMoney = computed(() =>
  selectRecords.value.reduce((t, c) => new Decimal(t).plus(new Decimal(c.settlementAmount)), 0)
);

const originalEditTypeOptions = [
  { label: '记账时间规则', value: 'accountTimeRule' },
  { label: '指定账期天数', value: 'paymentDays' },
  { label: '指定记账时间', value: 'accountDate' }
] as const;
const displayEditTypeOptions = computed(() => {
  type Writeable<T> = { -readonly [P in keyof T]: T[P] };
  const copy: any[] = cloneDeep(originalEditTypeOptions as Writeable<typeof originalEditTypeOptions>);
  copy.forEach((item) => {
    if (editModalDataList.value.some((data) => data.type === item.value)) {
      item.disabled = true;
    } else {
      item.disabled = false;
    }
  });
  return copy;
});

const checkboxChangeEvent = () => {
  const $table = tableRef.value;
  if ($table) {
    selectRecords.value = $table.getCheckboxRecords();
  }
};

const getOriginEditModalDataList = () => {
  return [{ id: 0 }] as { type?: typeof originalEditTypeOptions[number]['value']; value?: any; id: number }[];
};
const handleBatchEditBtnClick = () => {
  editModalVisible.value = true;
  editModalDataList.value = getOriginEditModalDataList();
};

const onTimeRuleChange = (val, row) => {
  
  row.accountDate = null;
  row.paymentDays = null;
  tableRef.value?.clearEdit();
};

const onConfirm = async () => {
  try {
    submitLoading.value = true;
    const data = cloneDeep(props._formData);
    data.tradeOrderDetails = props._dataSource;
    let errorMsg = '';
    data.tradeOrderDetails.forEach((item,index) => {
      delete item.__draftId;
      delete item._X_ROW_KEY;
      delete item.isSelected;
      if (item.accountTimeRule){
        if (item.accountTimeRule === 'DELIVERY_TIME' && !item.paymentDays) {
          errorMsg += `第${index+1}行，请设置指定账期天数\n\t`;
        }
        if (item.accountTimeRule === 'TARGET_TIME' && !item.accountDate) {
          errorMsg += `第${index+1}行，请设置指定记账时间\n\t`;
        }
      }
    });
    if (errorMsg) {
      OioMessage.error(errorMsg);
      return;
    }
    delete data.__draftId;
    await submitData(props.rModel, data);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    PopupManager.INSTANCE.close();
  } catch (error) {
    console.error(error);
  } finally {
    submitLoading.value = false;
  }
};

const onCancel = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  PopupManager.INSTANCE.close();
};

const addEditModalRow = () => {
  editModalDataList.value.push({
    id: count++
  });
};

const removeEditModalRow = (id: number) => {
  editModalDataList.value = editModalDataList.value.filter((item) => item.id !== id);
};

const onSubmitBatchEdit = () => {
  editModalVisible.value = false;
  tableLoading.value = true;
  try {
    applyBatchEdit();
  } finally {
    tableLoading.value = false;
  }
};

const applyBatchEdit = async () => {
  if (editModalDataList.value.every((item) => item.value === undefined)) {
    return;
  }
  selectRecords.value?.forEach((item) => {
    item.productOutCode &&
      editModalDataList.value.forEach(({ type, value }) => {
        if (type && value !== undefined) {
          item[type] = value;
          // 记账时间规则
          if (['accountTimeRule', 'paymentDays', 'accountDate'].includes(type)) {
            // 指定天数时，时间置空
            if (item.accountTimeRule === 'DELIVERY_TIME') {
              item.accountDate = null;
            }
            // 指定时间时，天数置空
            else {
              item.paymentDays = null;
            }
          }
        }
      });
  });
};

const updateDisplayTableData = () => {
  const oriData = props._dataSource;
  const keyList = searchVal.value.split(/[ \t\n]/).filter((s) => s);
  if (keyList.length === 0) {
    displayTableData.value = oriData;
  } else {
    displayTableData.value = oriData.filter((item) => {
      const condition1 = keyList.length
        ? keyList.some((key) =>
            ((item.productOutCode ?? '') + (item.itemName ?? '') + (item.eipItemCode ?? ''))?.includes?.(key)
          )
        : true;
      return condition1;
    });
  }
  checkboxChangeEvent();
};

// 注意有多处监听了_dataSource
watch(
  [() => props._dataSource, searchVal],
  () => {
    updateDisplayTableData();
  },
  {
    immediate: true
  }
);

const getPopupContainer = (triggerNode: HTMLElement) => {
  let curNode = triggerNode;
  while (curNode) {
    if (curNode.id === 'shop-product-content') {
      return curNode;
    }
    curNode = curNode.parentNode as HTMLElement;
  }
  return document.body;
};
const getModalContainer = () => {
  const container = document.getElementById('shop-product-content');
  return container ?? document.body;
};

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_vxe_table = _resolveComponent("vxe-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    id: "shop-product-content",
    ref_key: "contentRef",
    ref: contentRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: onConfirm,
            loading: submitLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_unref(OioButton), {
            type: "primary",
            disabled: !selectRecords.value.length,
            onClick: handleBatchEditBtnClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量修改")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(OioButton), { onClick: onCancel }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(OioInput), {
            value: searchVal.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchVal).value = $event)),
            placeholder: "按货号、商品名称、物料号搜索",
            style: {"width":"200px"},
            "allow-clear": ""
          }, null, 8, ["value"]),
          _createElementVNode("span", {
            style: {"font-size":"20px","margin-left":"10px","cursor":"pointer"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleFullscreen) && _unref(toggleFullscreen)(...args)))
          }, [
            (!_unref(isFullscreen))
              ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), { key: 1 }))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(OioSpin), { loading: tableLoading.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_vxe_table, {
              "header-align": "center",
              border: "",
              ref_key: "tableRef",
              ref: tableRef,
              height: "auto",
              "keep-source": "",
              "column-config": { resizable: true },
              data: displayTableData.value,
              "edit-config": { trigger: 'click', mode: 'cell', autoClear: false },
              "scroll-x": { enabled: false },
              "scroll-y": { enabled: true, gt: 0, oSize: 20 },
              "checkbox-config": { checkField: 'isSelected', reserve: true },
              "row-config": { keyField: 'id' },
              onCheckboxChange: _cache[4] || (_cache[4] = () => checkboxChangeEvent()),
              onCheckboxAll: _cache[5] || (_cache[5] = () => checkboxChangeEvent())
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  fixed: "left",
                  width: "50",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  type: "seq",
                  title: "行号",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  field: "",
                  title: "标签",
                  width: "80"
                }),
                _createVNode(_component_vxe_column, {
                  title: "考核标签",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_unref(OioTag), {
                      bordered: false,
                      color: scope.row.isExamine ? 'success' : 'warning'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.isExamine ?? true ? '考核' : '不考核'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "eipItemCode",
                  title: "ERP商品编码",
                  "min-width": "250",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemName",
                  title: "商品名称",
                  "min-width": "250",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "saleUnitName",
                  title: "包装单位",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemNum",
                  title: "下单数量(PCS)",
                  width: "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "priceType",
                  title: "价格类型",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "factoryPrice",
                  title: "出厂价",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "priceRatio",
                  title: "加价系数",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "specialDeductionRate",
                  title: "特殊扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "customerDiscount",
                  title: "客户扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "specialityDiscount",
                  title: "专业扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "promotionDeductionRate",
                  title: "活动扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "finalSettlementDeductionRate",
                  title: "结算扣率",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "settlementAmount",
                  title: "结算单价",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "itemNum",
                  title: "库存",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemNum",
                  title: "库存状态",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "isGifted",
                  title: "是否赠品",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.isGifted ? '是' : '否'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "settlementAmount",
                  title: "结算金额",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter)
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "promotionLablesStr",
                  title: "活动标签",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "ruleName",
                  title: "方案名称",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "ruleBackName",
                  title: "政策名称",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "policyLabel",
                  title: "政策标签",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "promotionSimpleCode",
                  title: "促销简码",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "accountTimeRule",
                  title: "记账时间规则",
                  "edit-render": {},
                  width: "150"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(timeRuleOptions.value.find((i) => i.value === scope.row.accountTimeRule)?.label), 1)
                  ]),
                  edit: _withCtx((scope) => [
                    _createVNode(_component_a_select, {
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      getPopupContainer: getPopupContainer,
                      placeholder: "请选择",
                      style: {"width":"100%"},
                      allowClear: "",
                      "default-active-first-option": false,
                      options: timeRuleOptions.value,
                      value: scope.row.accountTimeRule,
                      "onUpdate:value": ($event: any) => ((scope.row.accountTimeRule) = $event),
                      onChange: (val) => onTimeRuleChange(val, scope.row)
                    }, null, 8, ["options", "value", "onUpdate:value", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "paymentDays",
                  title: "指定账期天数",
                  "edit-render": {},
                  width: "150"
                }, {
                  edit: _withCtx((scope) => [
                    (scope.row.accountTimeRule === 'DELIVERY_TIME')
                      ? (_openBlock(), _createBlock(_component_a_input_number, {
                          key: 0,
                          value: scope.row.paymentDays,
                          "onUpdate:value": ($event: any) => ((scope.row.paymentDays) = $event),
                          class: "oio-input-number num-input",
                          placeholder: "请输入",
                          onBlur: _cache[2] || (_cache[2] = ($event: any) => (tableRef.value?.clearEdit())),
                          min: 1
                        }, null, 8, ["value", "onUpdate:value"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.paymentDays), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "accountDate",
                  title: "指定记账时间",
                  "edit-render": {},
                  width: "225"
                }, {
                  edit: _withCtx((scope) => [
                    (scope.row.accountTimeRule === 'TARGET_TIME')
                      ? (_openBlock(), _createBlock(_unref(OioDateTimePicker), {
                          key: 0,
                          value: scope.row.accountDate,
                          "onUpdate:value": ($event: any) => ((scope.row.accountDate) = $event),
                          placeholder: "请选择",
                          onBlur: _cache[3] || (_cache[3] = ($event: any) => (tableRef.value?.clearEdit()))
                        }, null, 8, ["value", "onUpdate:value"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.accountDate), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "isGroup",
                  title: "是否组合商品",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.isGroup ? '是' : '否'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(" 合计 "),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(removeDecimalZero)(_unref(totalMoney))), 1),
            _createTextVNode(" 元 ")
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_unref(OioModal), {
      visible: editModalVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((editModalVisible).value = $event)),
      title: "批量修改",
      width: "medium",
      "get-trigger-container": getModalContainer
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (editModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: onSubmitBatchEdit,
          loading: editModalConfirmLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editModalDataList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-row",
            key: item.id
          }, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: item.type,
                "onUpdate:value": ($event: any) => ((item.type) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                options: _unref(displayEditTypeOptions),
                getPopupContainer: getPopupContainer
              }, null, 8, ["value", "onUpdate:value", "options"])
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (item.type && ['accountTimeRule'].includes(item.type))
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 0,
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    getPopupContainer: getPopupContainer,
                    placeholder: "不修改",
                    style: {"width":"100%"},
                    "default-active-first-option": false,
                    options: timeRuleOptions.value,
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event)
                  }, null, 8, ["options", "value", "onUpdate:value"]))
                : (item.type && ['paymentDays'].includes(item.type))
                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                      key: 1,
                      value: item.value,
                      "onUpdate:value": ($event: any) => ((item.value) = $event),
                      class: "oio-input-number num-input",
                      placeholder: "不修改",
                      min: 1
                    }, null, 8, ["value", "onUpdate:value"]))
                  : (item.type && ['accountDate'].includes(item.type))
                    ? (_openBlock(), _createBlock(_unref(OioDateTimePicker), {
                        key: 2,
                        value: item.value,
                        "onUpdate:value": ($event: any) => ((item.value) = $event),
                        placeholder: "不修改"
                      }, null, 8, ["value", "onUpdate:value"]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createVNode(_unref(MinusCircleOutlined), {
                onClick: ($event: any) => (removeEditModalRow(item.id))
              }, null, 8, ["onClick"]), [
                [_vShow, editModalDataList.value.length > 1]
              ]),
              _withDirectives(_createVNode(_unref(PlusCircleOutlined), { onClick: addEditModalRow }, null, 512), [
                [_vShow, index === editModalDataList.value.length - 1 && index !== _unref(displayEditTypeOptions).length - 1]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}
}

})